/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

/**
 * Web-only mock: Google Mobile Ads is native-only. This file is used when building for web
 * so the real HomeMobileAd.tsx (and react-native-google-mobile-ads) is never loaded.
 */

import type { MobileAdsProps } from './HomeMobileAdsType';

const HomeMobileAd = (_props: MobileAdsProps) => {
  void _props;
  return null;
};

export default HomeMobileAd;
